<div class="item_card_wrap">
    <div class="card_con">
        <img src="assets/imgs/speaker_icon.png" alt="스피커 아이콘">
        <div class="text_box">
            <span>스마트 스피커</span>
        </div>
    </div>
</div>